module.exports = __webpack_public_path__ + "img/NoSearch@2x.8751689c.png";